import env from '@/env'

export default {
  advertise: {
    visible: false,
    link: '',
    image: {
      src: '',
      alt: '',
    },
  },
  version: {
    system: env.releaseVersion(),
    latest: env.latestVersion(),
  },
  clientName: 'Involves Stage',
  clientLogo: '',
  isAuthenticated: false,
  isLoading: false,
}
